"use client";

import "@/app/globals.css";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import Footer from "@/shared/components/Footer";
import Navbar from "@/shared/components/Navbar/Navbar";
import { Space_Grotesk } from "next/font/google";

const spaceGrotesk = Space_Grotesk({
  subsets: ["latin"],
  variable: "--font-sans",
  display: "swap",
});

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [queryClient] = useState(function createQueryClient() {
    return new QueryClient({
      defaultOptions: {
        queries: {
          refetchInterval: 2 * 60e3,
          staleTime: 2 * 60e3,
          gcTime: 3 * 60e3,
        },
      },
    });
  });

  return (
    <html lang="en">
      <body className={"antialiased " + spaceGrotesk.variable}>
        <a
          href="#blog"
          className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] rounded-md bg-blue px-3 py-2 text-white"
        >
          Skip to content
        </a>
        <NuqsAdapter>
          <QueryClientProvider client={queryClient}>
            <div className="relative">
              <Navbar />
              {children}
              <Footer />
            </div>
          </QueryClientProvider>
        </NuqsAdapter>
      </body>
    </html>
  );
}
